import React from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { useScreenWidth } from '../hooks/useScreenWidth'

export default function CalculatorPage() {
  const isMobile = useScreenWidth(768);
  return (
    <>
    <div>
        <nav className='calc-nav'>
        <ul>
          <li><NavLink to="penalitate">Penalitate</NavLink></li>
          <li><NavLink to="dobanda">{isMobile ? "Dobânda":"Dobânda de întârziere"}</NavLink></li>
          <li><NavLink to="inflatie">{isMobile ? "Inflație":"Calcul inflație"}</NavLink></li>
          <li><NavLink to="imputatia">Imputația</NavLink></li>
          <li><NavLink to="zile">{isMobile ? "Zile":"Calcul zile"}</NavLink></li>
          {isMobile && <li><a href="https://taxa.prolex.md" className="navbar-link" target="_blank">Taxa</a></li>}
        </ul>
        </nav>
    </div>
    <Outlet/>
    </>
  )
}
